import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import SearchResultHeader from "./SearchResultHeader";
import BusinessUccNimbusRecordHeader from "./BusinessUccNimbusRecordHeader";
import BusinessBccNimbusItemRecordDetail from "./BusinessBccNimbusItemRecordDetail";
import { getMenuItem } from "../common/PageHelper";
import BusinessBccNimbusItemRecordFullDetail from "./BusinessBccNimbusItemRecordFullDetail";

class BusinessUccNimbusResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportId: null,
    };
  }

  onSelectReport = (selectedReportId) => {
    this.state = { selectedReportId };
  };

  render() {
    const results = [];
    let tabHeader = null;
    if (
      this.props.searchResultData !== undefined &&
      this.props.searchResultData !== null &&
      this.props.searchResultData !== ""
    ) {
      const records = _.get(
        this.props.searchResultData,
        `${Object.keys(this.props.searchResultData)[0]
        }.response[0].output[0].UCCFilings[0].UCCFiling`
      );

      if (records !== undefined) {
        const showNarrowSearchMessage = records && records.length > 25;
        tabHeader = (
          <SearchResultHeader
            showNarrowSearchMessage={showNarrowSearchMessage}
            log={_.get(
              this.props.searchResultData,
              `${Object.keys(this.props.searchResultData)[0]}.log[0]`
            )}
            {...this.props}
            printContent={this.props.printContent}
          />
        );
        _.forEach(records, (record, index) => {
          const header = (
            <Table.Row key={`Business_Ucc_Header_Row_${index}`}>
              <Table.Cell>
                <BusinessUccNimbusRecordHeader
                  key={`Business_Ucc_Header_Table_${index}`}
                  node={record}
                  index={index}
                  showReportButton
                  onSelectReport={this.onSelectReport}
                  {...this.props}
                  companyName={_.get(
                    record,
                    "debtors[0].debtor[0].businessName[0]._",
                    ""
                  )}
                  userAccount={this.props.userAccount}
                />
              </Table.Cell>
            </Table.Row>
          );
          const body = (
            <Table.Row key={`Business_Ucc_Body_Table_Row_${index}`}>
              <Table.Cell>
                <BusinessBccNimbusItemRecordDetail
                  key={`Business_Ucc_Body_Table_${index}`}
                  node={record}
                  index={index}
                  {...this.props}
                />
              </Table.Cell>
            </Table.Row>
          );
          results.push(header);

          results.push(body);
        });
      } else {
        const record = _.get(
          this.props.searchResultData,
          `${Object.keys(this.props.searchResultData)[0]
          }.UCCFiling[0]`
        );
        if (record) {
          const header = (
            <Table.Row key={`Business_Ucc_Header_Row_1`}>
              <Table.Cell>
                <BusinessUccNimbusRecordHeader
                  key={`Business_Ucc_Header_Table_1`}
                  node={record}
                  index={1}
                  onSelectReport={this.onSelectReport}
                  {...this.props}
                  companyName={_.get(
                    record,
                    "debtors[0].debtor[0].businessName[0]._",
                    ""
                  )}
                  userAccount={this.props.userAccount}
                />
              </Table.Cell>
            </Table.Row>
          );
          const body = (
            <Table.Row key={`Business_Ucc_Body_Table_Row_1`}>
              <Table.Cell>
                <BusinessBccNimbusItemRecordFullDetail
                  key={`Business_Ucc_Body_Table_1`}
                  node={record}
                  index={1}
                  {...this.props}
                />
              </Table.Cell>
            </Table.Row>
          );
          results.push(header);

          results.push(body);
        }
      }
    }

    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${results.length > 0 ? results.length / 2 : 0} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          <Table stackable>
            <Table.Body>{results}</Table.Body>
          </Table>
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(BusinessUccNimbusResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/BusinessUccNimbusResult.js